import * as TYPES from '../types';

export const practiceFields = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case TYPES.REPLACE_PRACTICE_FIELDS:
      newState = { ...newState, fields: action.fields };
      return newState;
    case TYPES.SET_PRACTICE_AREA_ACTIONS:
      newState = { ...newState, actions: action.actions };
      return newState;
    default:
      return state;
  }
};
